import getDecryptedToken from "../api/getDecryptedToken";

export function isPrintTemplate2Enabled(): boolean {
  return getDecryptedToken("featurePrintTemplate2") === "true";
}

export function isCertificatePrintEnabled(): boolean {
  return getDecryptedToken("featureCertificatePrint") === "true";
}

export function isDoctorTransferEnabled(): boolean {
  return getDecryptedToken("featureDoctorTransfer") === "true";
}

export function isPromotionalSmsEnabled(): boolean {
  return getDecryptedToken("featurePromotionalSms") === "true";
}
